/** Shared labels for Marketing Suite contact/subscriber sources. */

export const SOURCE_MANUAL = 'manual';
export const SOURCE_LEAD_SCRAPER = 'lead_scraper';
export const SOURCE_WEBSITE_NEWSLETTER = 'website_newsletter';
export const SOURCE_WEBSITE_CONTACT_FORM = 'website_contact_form';

export const SOURCE_LABELS = {
  [SOURCE_MANUAL]: 'Manual',
  [SOURCE_LEAD_SCRAPER]: 'Lead Scraper',
  [SOURCE_WEBSITE_NEWSLETTER]: 'Website newsletter',
  [SOURCE_WEBSITE_CONTACT_FORM]: 'Website contact form',
  website: 'Website form',
  gmaps_scraper: 'Lead Scraper',
  lead_pipeline: 'Lead Scraper',
  crm_lead: 'CRM sync',
  account_sync: 'Account sync',
  website_subscriber: 'Website subscriber',
  form: 'Website form',
  import: 'Import',
  api: 'API',
  checkout: 'Checkout',
  referral: 'Referral',
  event: 'Event',
  cold_outreach: 'Cold outreach',
};

export const PROTECTED_EMAIL_LIST_NAMES = new Set([
  'Website Newsletter',
  'Website Contact Forms',
  'Lead Scraper',
  'CRM & Leads',
]);

const SCRAPER_ALIASES = new Set(['lead_scraper', 'gmaps_scraper', 'lead_pipeline', 'lead-pipeline']);

export function normalizeContactSource(source) {
  const key = String(source || '').trim().toLowerCase();
  if (!key || key === SOURCE_MANUAL) return SOURCE_MANUAL;
  if (SCRAPER_ALIASES.has(key)) return SOURCE_LEAD_SCRAPER;
  if (key === 'website' || key === 'website_form' || key === 'form') return SOURCE_WEBSITE_CONTACT_FORM;
  return key;
}

export function sourceLabel(source) {
  const key = normalizeContactSource(source);
  return SOURCE_LABELS[key] || (key ? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : 'Unknown');
}

export const CRM_SOURCE_OPTIONS = [
  { value: '', label: 'All sources' },
  { value: SOURCE_MANUAL, label: SOURCE_LABELS[SOURCE_MANUAL] },
  { value: SOURCE_LEAD_SCRAPER, label: SOURCE_LABELS[SOURCE_LEAD_SCRAPER] },
  { value: SOURCE_WEBSITE_CONTACT_FORM, label: SOURCE_LABELS[SOURCE_WEBSITE_CONTACT_FORM] },
  { value: SOURCE_WEBSITE_NEWSLETTER, label: SOURCE_LABELS[SOURCE_WEBSITE_NEWSLETTER] },
  { value: 'referral', label: SOURCE_LABELS.referral },
  { value: 'event', label: SOURCE_LABELS.event },
  { value: 'cold_outreach', label: SOURCE_LABELS.cold_outreach },
];

export const SUBSCRIBER_SOURCE_OPTIONS = [
  { value: '', label: 'All sources' },
  { value: SOURCE_MANUAL, label: SOURCE_LABELS[SOURCE_MANUAL] },
  { value: SOURCE_LEAD_SCRAPER, label: SOURCE_LABELS[SOURCE_LEAD_SCRAPER] },
  { value: SOURCE_WEBSITE_NEWSLETTER, label: SOURCE_LABELS[SOURCE_WEBSITE_NEWSLETTER] },
  { value: SOURCE_WEBSITE_CONTACT_FORM, label: SOURCE_LABELS[SOURCE_WEBSITE_CONTACT_FORM] },
];
